import React, {
  CSSProperties,
  FunctionComponent,
  ReactNode,
  useEffect,
  useRef,
  useState,
} from "react";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

import "./Modal.scss";

type Props = {
  children?: ReactNode;
  isOpen: boolean;
  toggle: () => void;
  style?: CSSProperties;
};

const Modal: FunctionComponent<Props> = ({
  isOpen,
  children,
  toggle,
  style = {},
}) => {
  const targetRef = useRef<null | HTMLDivElement>(null);
  const innerModalRef = useRef<null | HTMLDivElement>(null);

  // body scroll lock

  useEffect(() => {
    if (targetRef.current) disableBodyScroll(targetRef.current);

    return () => {
      if (targetRef.current) enableBodyScroll(targetRef.current);
    };
  }, [targetRef.current]);

  const closeModal = () => {
    if (targetRef.current) enableBodyScroll(targetRef.current);
    toggle();
  };

  // handle click outside
  const handleClickOutside = (event: any) => {
    if (
      innerModalRef &&
      innerModalRef.current &&
      !innerModalRef.current.contains(event.target)
    ) {
      closeModal();
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  // handle close
  const handleToggle: React.MouseEventHandler<HTMLDivElement> = (e) => {
    e.preventDefault();
    closeModal();
  };

  if (!isOpen) return null;

  return (
    <div ref={targetRef} className="modal">
      <div ref={innerModalRef} className="modal-overlay" onClick={handleToggle}>
        <div
          onClick={(e) => e.stopPropagation()}
          className="modal-box"
          style={style}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
